import React from "react";
import { Alert, Container } from "reactstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { alertAction } from "../../_actions";
import { withTranslation } from "react-i18next";

class Notification extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      alerts: []
    };
  }

  whichColor() {
    const { notification } = this.props;
    if (notification.level == "notification") return "success";
    if (notification.level == "error") return "danger";
    return "warning";
  }

  componentDidUpdate() {
    // const { notification } = this.props;
    // if (notification.message != "") {
    //   notification.time = Date.now();
    //   this.setState(
    //     {
    //       alerts: [...this.state.alerts, notification]
    //     },
    //     this.props.hide()
    //   );
    // }
    // // console.log(this.state.alerts);

    // if(this.state.alerts != []){
    //     setInterval(() => {
    //       let time = Date.now();
    //       this.setState({

    //         alerts: this.state.alerts.filter((item:any) => {
    //         return time < item.time + (5000);
    //         }
    //       )
    //     })

    //   }, 10000);
    // }

  }

  renderAlerts() {
    // console.log(this.state.alerts);

    return (this.state.alerts || []).map((notification: any, index: any) => {
      return(
        <Alert
          key={index}
          color={this.whichColor()}
          style={{ marginTop: "25px" }}
          onClick={() => this.props.hide()}
        >
          {console.log("SADASDASDAS")}
          {console.log(notification)}
          {notification.message}
          asdasd
        </Alert>
      )
    });
  }

  render() {
    const { t, notification } = this.props;
    return (
      <>
    {console.log(t)}
        <Container>
          {notification.message != "" && (
            <Alert
              color={this.whichColor()}
              style={{ marginTop: "25px" }}
              onClick={() => this.props.hide()}
            >
              <div>
              {t(notification.message)}

                <div style={{float: "right"}}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                  <path d="M0 0h24v24H0z" fill="none"/>
                  </svg>
                </div>
              </div>

            </Alert>
          )}

          {/* {this.renderAlerts()} */}
        </Container>
      </>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    notification: state.alert.notification
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators(
    {
      hide: alertAction.hide
    },
    dispatch
  );
};

const NotificationComponent = connect(
  mapStateToProps,
  mapDispatchToProps
  )(withTranslation('notification')(Notification));

export { NotificationComponent as Notification };
